export default __webpack_public_path__ + "images/fdbea9a8186cbf926987c684c4e5b87c.svg";